export default __webpack_public_path__ + "images/rosabandet/ica/ica-logo.png";